import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CourtDiagram } from './CourtDiagram';
const parts = ["What you're working on today", 'Court setup, equipment and duration', 'How to split the group', 'A short cue script to explain it', 'Warm-up game → skill block → applied game', 'When to rotate and how to score it', 'What to watch for, the common error and the fix', 'Easier, harder and the 3-Level Dial'];
const legend = [{
  dot: 'bg-night',
  label: 'Coach'
}, {
  dot: 'bg-court',
  label: 'Player'
}, {
  dot: 'bg-shuttle',
  label: 'Feeder'
}];

/** Shown in the second review slot until real buyer reviews are added. */
export function SessionAnatomy() {
  return <section aria-labelledby="anatomy-heading" className="w-full bg-light" data-id="element-285" data-mp="2w8lpzwy4ixko">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-286" data-mp="2w9wr1p06pr83">
        <div className="text-center" data-id="element-287" data-mp="1zpo4rli0nmcn">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-court" data-id="element-288" data-mp="23rriyhw2l51m">
            What you open on the day
          </p>
          <h2 id="anatomy-heading" className="mt-3 font-display font-bold text-ink text-[28px] leading-tight tracking-tight sm:text-5xl" data-id="element-289" data-mp="3p1c7b6py1muu">
            Every session answers the questions before you ask them
          </h2>
        </div>

        <div className="mt-9 grid items-center gap-6 md:grid-cols-[.8fr_1.2fr]" data-id="element-290" data-mp="3adr4zf0w7rnz">
          <div className="mx-auto w-full max-w-[260px] rounded-2xl border border-line bg-white p-4 shadow-card" data-id="element-291" data-mp="3abn290eqcypa">
            <CourtDiagram data-id="element-292" data-mp="31d1d2mer6lfj" />
            <ul className="mt-2 flex justify-center gap-4" data-id="element-293" data-mp="31cjgtps3c77m">
              {legend.map(l => <li key={l.label} className="flex items-center gap-1.5 text-[11px] font-semibold text-ink-soft" data-id="element-294" data-mp="2wcwxqzpkzwqw">
                  <span className={`h-2.5 w-2.5 rounded-full ${l.dot}`} data-id="element-295" data-mp="2rfwzhayz3yac" />
                  {l.label}
                </li>)}
            </ul>
          </div>

          <ul className="grid gap-2.5" data-id="element-296" data-mp="pmqq9d9v7i9g">
            {parts.map(p => <li key={p} className="flex items-start gap-3 rounded-xl border border-line bg-white px-4 py-3 text-sm font-medium text-ink" data-id="element-297" data-mp="2k3gzd5inibj2">
                <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-green" data-id="element-298" data-mp="2ov8rhkhggpbb">
                  <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-299" data-mp="2a6m4qxpi0va2" />
                </span>
                {p}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}